// NEW: UI_REVAMP
import dayjs from 'dayjs';
import React from 'react';
import { RECORD_FILTER_CHIP_STYLES } from '../../styles/recordUiTokens';
import AppliedFilterChips from '../filter/AppliedFilterChips';
import { getTransactionStatusStyle } from './transactionStatusStyles';

const AppliedTransactionFilters = ({
	startDate,
	endDate,
	transactionType,
	onClearDateRange,
	onClearTransactionType,
}) => {
	const hasDateRangeFilter = Boolean(startDate && endDate);
	const isDefaultDateRange =
		hasDateRangeFilter &&
		dayjs(startDate).isSame(dayjs(), 'day') &&
		dayjs(endDate).isSame(dayjs(), 'day');
	const hasTransactionType = transactionType && transactionType !== 'ALL';
	const transactionTypeStyle = getTransactionStatusStyle(transactionType);
	const chips = [
		hasDateRangeFilter
			? {
					key: 'date-range',
					label: `${dayjs(startDate).format('YYYY-MM-DD')} - ${dayjs(endDate).format('YYYY-MM-DD')}`,
					...RECORD_FILTER_CHIP_STYLES.dateRange,
					onClear: isDefaultDateRange ? undefined : onClearDateRange,
				}
			: null,
		hasTransactionType
			? {
					key: 'transaction-type',
					label: transactionTypeStyle.label,
					background: transactionTypeStyle.background,
					color: transactionTypeStyle.color,
					onClear: onClearTransactionType,
				}
			: null,
	];

	return <AppliedFilterChips chips={chips} />;
};

export default AppliedTransactionFilters;
